import service from '@/utils/server';

const modName='/toxin/toxinInspectVehicleArragement/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//是否免检设定
export const toxinInspectSetVehicleSave = data => {
  return service({
    url: modName + 'toxinInspectSetVehicleSave',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleArragement/api/index.js